<template>
  <div 
    class="overlay-modal"
    :class="`${isModalOpen ? 'open' : 'closed'}`"
  >
    <slot 
      v-if="isModalOpen"
    >

    </slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalOpen: false,
    };
  },

  methods: { 
    openModal() {
      this.isModalOpen = true
      document.body.style.overflow = 'hidden';
    },

    closeModal() {
      this.isModalOpen = false
      document.body.style.overflow = 'visible';
    },
  }
};

</script>

<style scoped>
.overlay-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  z-index: 1000;
  transition: all .3s;
}

@media (min-width: 768px) {
  .overlay-modal.open {
    display: flex;
  }

  .overlay-modal.closed {
    display: none;
  }
}

@media (max-width: 768px) {
  .overlay-modal.open {
    transform: translateY(0);
  }
  
  .overlay-modal.closed {
    transform: translateY(1000px);
  }
}
</style>
